define([
    './defined',
    './defaultValue',
    '../System/ColorObj'
], function (
    defined,
    defaultValue,
    ColorObj
) {
    'use strict'

    /**
     * 将一定规则的字符串转成ColorObj对象数组，用于对象还原。
     *
     * @private
     *
     * @exports string2ColorArray
     */
    const string2ColorArray = (str, sp1, sp2) => {
        let splitStr1 = defaultValue(sp1, ",")
        let splitStr2 = defaultValue(sp2, ";")
        let result = []

        // 拆分成每个对象的字符串
        let objStrings = str.split(splitStr2)

        for (let i = 0; i < objStrings.length; ++i) {
            if (objStrings[i].trim() === "") continue // 跳过空字符串

            // 拆分每个对象的属性值
            let values = objStrings[i].split(splitStr1)
            if (values.length >= 4) {
                // 将属性值转换为对象并添加到结果数组中
                let obj = new ColorObj(parseFloat(values[0]), parseFloat(values[1]), parseFloat(values[2]), parseFloat(values[3]))
                result.push(obj)
            }
        }
        return result
    }
    return string2ColorArray
});
